<template>
  <div>
    <v-tabs v-model="tab">
      <!-- <v-tab>ข้อมูลส่วนตัว</v-tab> -->
      <v-tab>เปลี่ยนรหัสผ่าน</v-tab>
    </v-tabs>

    <v-divider></v-divider>

    <v-tabs-items v-model="tab" class="blue-grey lighten-4">
      <!-- <v-tab-item>
        <v-container fluid>
          <v-row justify="center">
            <v-col md="8" lg="8" xl="6">
              <v-card>
                <v-card-title>
                  <span class="font-weight-regular">ข้อมูลส่วนตัว</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-progress-linear
                  :active="loading"
                  :indeterminate="loading"
                ></v-progress-linear>
                <v-card-text class="pa-5">
                  <v-form
                    ref="formChangeEmail"
                    lazy-validation
                    @submit.prevent="onClickChangeEmail"
                  >
                    <label class="body-2">
                      อีเมล
                      <span class="red--text"><strong>*</strong></span>
                    </label>
                    <v-text-field
                      class="fix-google-chrome mt-1"
                      tabindex="1"
                      v-model="email"
                      :rules="emailRules"
                      required
                      clearable
                      @change="checkEmpty($event, 'email')"
                      outlined
                      dense
                    ></v-text-field>
                    <div class="mt-5">
                      <v-btn
                        tabindex="2"
                        type="submit"
                        class="mr-4"
                        color="primary"
                        @click="onClickChangeEmail"
                        disabled
                        >เปลี่ยนอีเมล
                      </v-btn>
                    </div>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="2" v-if="drawer"></v-col>
          </v-row>
        </v-container>
      </v-tab-item> -->
      <v-tab-item>
        <v-container fluid>
          <v-row justify="center">
            <v-col md="8" lg="8" xl="6">
              <v-card>
                <v-card-title>
                  <span class="font-weight-regular">เปลี่ยนรหัสผ่าน</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-progress-linear
                  :active="loading"
                  :indeterminate="loading"
                ></v-progress-linear>
                <v-card-text class="pa-5">
                  <v-form
                    ref="formChangePassword"
                    lazy-validation
                    @submit.prevent="onClickChangePassword"
                  >
                    <label class="body-2">
                      รหัสผ่านเดิม
                      <span class="red--text"><strong>*</strong></span>
                    </label>
                    <v-text-field
                      class="fix-google-chrome mt-1"
                      tabindex="1"
                      v-model="oldPassword"
                      :rules="oldPasswordRules"
                      type="password"
                      autocomplete="off"
                      placeholder="กรุณากรอกรหัสผ่านเดิม"
                      required
                      clearable
                      outlined
                      dense
                    >
                    </v-text-field>
                    <label class="body-2">
                      รหัสผ่านใหม่
                      <span class="red--text"><strong>*</strong></span>
                    </label>
                    <v-text-field
                      class="fix-google-chrome mt-1"
                      tabindex="2"
                      v-model="newPassword"
                      type="password"
                      autocomplete="off"
                      placeholder="กรุณากรอกรหัสผ่านใหม่"
                      required
                      clearable
                      outlined
                      dense
                      hide-details
                    >
                    </v-text-field>
                    <v-text-field
                      class="fix-google-chrome mt-3"
                      tabindex="3"
                      v-model="confirmPassword"
                      type="password"
                      autocomplete="off"
                      placeholder="กรุณากรอกรหัสผ่านใหม่ อีกครั้ง"
                      required
                      clearable
                      outlined
                      dense
                    >
                    </v-text-field>
                    <div>
                      <div class="d-flex align-end mt-1">
                        <v-icon
                          v-if="isPasswordRuleMinimumLengthValid"
                          color="success"
                        >
                          mdi-check-circle
                        </v-icon>
                        <v-icon v-else color="error">mdi-close-circle</v-icon>
                        <span class="ml-1">
                          ความยาว {{ passwordMinimumLength }}-128 ตัวอักษร
                        </span>
                      </div>
                      <div
                        v-if="isPasswordRuleUpper"
                        class="d-flex align-end mt-1"
                      >
                        <v-icon v-if="isPasswordRuleUpperValid" color="success">
                          mdi-check-circle
                        </v-icon>
                        <v-icon v-else color="error">mdi-close-circle</v-icon>
                        <span class="ml-1">
                          อักษรอังกฤษตัวพิมพ์ใหญ่ (A-Z) อย่างน้อย 1 ตัวอักษร
                        </span>
                      </div>
                      <div
                        v-if="isPasswordRuleLower"
                        class="d-flex align-end mt-1"
                      >
                        <v-icon v-if="isPasswordRuleLowerValid" color="success">
                          mdi-check-circle
                        </v-icon>
                        <v-icon v-else color="error">mdi-close-circle</v-icon>
                        <span class="ml-1">
                          อักษรอังกฤษตัวพิมพ์เล็ก (a-z) อย่างน้อย 1 ตัวอักษร
                        </span>
                      </div>
                      <div
                        v-if="isPasswordRuleNumber"
                        class="d-flex align-end mt-1"
                      >
                        <v-icon
                          v-if="isPasswordRuleNumberValid"
                          color="success"
                        >
                          mdi-check-circle
                        </v-icon>
                        <v-icon v-else color="error">mdi-close-circle</v-icon>
                        <span class="ml-1">ตัวเลข (0-9) อย่างน้อย 1 ตัว</span>
                      </div>
                      <div
                        v-if="isPasswordRuleNonAlphanumeric"
                        class="d-flex align-end mt-1"
                      >
                        <v-icon
                          v-if="isPasswordRuleNonAlphanumericValid"
                          color="success"
                        >
                          mdi-check-circle
                        </v-icon>
                        <v-icon v-else color="error">mdi-close-circle</v-icon>
                        <span class="ml-1">
                          อักขระพิเศษ (เช่น $%#@!~_-?) อย่างน้อย 1 ตัวอักษร
                        </span>
                      </div>
                      <div
                        v-if="isPasswordRulePreventPasswordSameAsEmployeeCode"
                        class="d-flex align-end mt-1"
                      >
                        <v-icon
                          v-if="
                            isPasswordRulePreventPasswordSameAsEmployeeCodeValid
                          "
                          color="success"
                        >
                          mdi-check-circle
                        </v-icon>
                        <v-icon v-else color="error">mdi-close-circle</v-icon>
                        <span class="ml-1">รหัสผ่านไม่ซำ้กับรหัสพนักงาน</span>
                      </div>
                      <div class="d-flex align-end mt-1">
                        <v-icon
                          v-if="isPasswordConfirmPasswordValid"
                          color="success"
                        >
                          mdi-check-circle
                        </v-icon>
                        <v-icon v-else color="error">mdi-close-circle</v-icon>
                        <span class="ml-1">รหัสผ่านใหม่ตรงกันทั้ง 2 ช่อง</span>
                      </div>
                    </div>
                    <div class="mt-5">
                      <v-btn
                        tabindex="4"
                        type="submit"
                        class="mr-4"
                        color="primary"
                        :disabled="loading"
                        >เปลี่ยนรหัสผ่าน
                      </v-btn>
                    </div>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="2" v-if="drawer"></v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      tab: null,
      loading: false,
      email: '',
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      emailRules: [
        (v) => !!v || 'โปรดระบุอีเมล',
        (v) => /.+@.+\..+/.test(v) || 'อีเมลไม่ถูกต้อง',
      ],
      oldPasswordRules: [(v) => !!v || 'โปรดระบุรหัสผ่านเดิม'],
    }
  },
  computed: {
    drawer() {
      return this.$store.state.drawer
    },
    user() {
      return this.$store.state.authentication.user || {}
    },
    passwordPolicy() {
      return this.$store.state.password.passwordPolicy
    },
    passwordMinimumLength() {
      return this.passwordPolicy?.password_minimum_length?.value || 6
    },
    isPasswordRuleUpper() {
      return this.passwordPolicy?.require_latin_upper_case?.is_enable
    },
    isPasswordRuleLower() {
      return this.passwordPolicy?.require_latin_lower_case?.is_enable
    },
    isPasswordRuleNumber() {
      return this.passwordPolicy?.require_number?.is_enable
    },
    isPasswordRuleNonAlphanumeric() {
      return this.passwordPolicy?.require_non_alphanumeric?.is_enable
    },
    isPasswordRulePreventPasswordSameAsEmployeeCode() {
      return this.passwordPolicy?.prevent_password_same_as_employee_code
        ?.is_enable
    },
    isPasswordRuleMinimumLengthValid() {
      return this.newPassword.length >= this.passwordMinimumLength
    },
    isPasswordRuleUpperValid() {
      return /[A-Z]/.test(this.newPassword)
    },
    isPasswordRuleLowerValid() {
      return /[a-z]/.test(this.newPassword)
    },
    isPasswordRuleNumberValid() {
      return /[0-9]/.test(this.newPassword)
    },
    isPasswordRuleNonAlphanumericValid() {
      return /[^A-Za-z0-9 ]/.test(this.newPassword)
    },
    isPasswordRulePreventPasswordSameAsEmployeeCodeValid() {
      return this.newPassword !== this.user.employee_code
    },
    isPasswordConfirmPasswordValid() {
      return this.newPassword === this.confirmPassword
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ข้อมูลส่วนตัว',
        disabled: true,
      },
    ])

    try {
      this.$store.state.loading = true

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
      }

      await this.fetchPasswordPolicy(payload)
    } catch (error) {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    } finally {
      this.$store.state.loading = false
    }
  },
  methods: {
    ...mapActions({
      logout: 'authentication/logout',
      changePassword: 'authentication/changePassword',
      fetchPasswordPolicy: 'password/fetchPasswordPolicy',
    }),
    onClickChangeEmail() {
      if (this.$refs.formChangeEmail.validate()) {
        // TODO: edit email
      }
    },
    onClickChangePassword() {
      if (this.$refs.formChangePassword.validate()) {
        if (!this.isPasswordRuleMinimumLengthValid) return
        if (this.isPasswordRuleUpper && !this.isPasswordRuleUpperValid) return
        if (this.isPasswordRuleLower && !this.isPasswordRuleLowerValid) return
        if (this.isPasswordRuleNumber && !this.isPasswordRuleNumberValid) return
        if (
          this.isPasswordRuleNonAlphanumeric &&
          !this.isPasswordRuleNonAlphanumericValid
        )
          return
        if (
          this.isPasswordRulePreventPasswordSameAsEmployeeCode &&
          !this.isPasswordRulePreventPasswordSameAsEmployeeCodeValid
        )
          return
        if (!this.isPasswordConfirmPasswordValid) return

        this.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const { uuid: account_uuid } = this.$store.state.authentication.user

        const payload = {
          company_uuid,
          account_uuid,
          account_type: this.user.email ? 'admin' : 'employee',
          body: {
            password: this.oldPassword,
            password_new: this.newPassword,
          },
        }

        this.changePassword(payload)
          .then(() => {
            this.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 4000,
              message: 'เปลี่ยนรหัสผ่านสำเร็จ กรุณาเข้าระบบใหม่',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            window.localStorage.removeItem('company')
            window.localStorage.removeItem('user')

            this.$router.push({ path: '/?logout' })

            // this.$router.push({ path: '/login' })
          })
          .catch((error) => {
            this.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    checkEmpty(value, field) {
      if (value) {
        this[field] = value.trim()
      }
    },
  },
}
</script>
